






















































































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import {
  UnreimburseExpense,
  ReimbursementRequest,
  RgbColor,
  GradientPoint,
} from "@/shared/types";
import Widget from "@/shared/components/Widget.vue";
import Search from "@/shared/components/Search.vue";
import Button from "@/shared/components/ui/Button.vue";
import ExpenseRow from "@/shared/components/expense/ExpenseRow.vue";
import UnreimbursedRow from "@/employee/components/healthcareExpense/UnreimbursedRow.vue";
import BottomNotification from "@/shared/components/BottomNotification.vue";
import ReimburseMePopup from "@/employee/components/shared/ReimburseMePopup.vue";
import Pagination from "@/shared/components/ui/Pagination.vue";
import SliderArrow from "@/shared/components/ui/SliderArrow.vue";
import SideBar from "@/employee/components/healthcareExpense/SideBar.vue";
import { formatCurrency } from "@/shared/currency";
import {
  tint,
  covertHexToRgbColor,
  convertColorToHex
} from "@/shared/colorAdjuster";
import HealthcareExpenseNavigation from "@/employee/components/healthcareExpense/HealthcareExpenseNavigation.vue";
import HealthcareExpensesAdd from "@/employee/components/healthcareExpense/HealthcareExpensesAdd.vue";
import PocGLineChart from "@/shared/components/charts/PocGLineChart.vue";
import { useThemeStore } from "@/shared/store/theme";
import { useExpenseUnreimbursedStore } from "@/employee/store/expenseUnreimbursed";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useExpenseBalanceSummaryStore } from "@/employee/store/expenseBalanceSummary";
import { useReimburseMeStore } from "@/employee/store/reimburseMe";
import { useExpenseStore } from "@/employee/store/expense";

@Component({
  components: {
    Widget,
    Search,
    Button,
    ExpenseRow,
    BottomNotification,
    ReimburseMePopup,
    Pagination,
    SliderArrow,
    UnreimbursedRow,
    SideBar,
    HealthcareExpenseNavigation,
    HealthcareExpensesAdd,
    PocGLineChart
  }
})
export default class HealthcareExpensesUnreimbursed extends Vue {
  unreimbursedStore = useExpenseUnreimbursedStore();
  custodianSettingsStore = useCustodianSettingsStore();
  expenseStore = useExpenseStore();
  expenseBalanceSummaryStore = useExpenseBalanceSummaryStore();
  reimburseMeStore = useReimburseMeStore();
  themeStore = useThemeStore();

  showExpenseAddView = false;
  showReimbursePopup = false;
  formatCurrency = formatCurrency;

  negativeDataSetFillGradient: GradientPoint[] = [
    {
      alpha: 1.0,
      color: "#fff"
    },
    {
      alpha: 1.0,
      color: "#fff"
    }];

  @Prop() addExpenseAction: () => void;
  @Prop() displayPersonalExpenseTracker: boolean;

  mounted (): void {
    this.unreimbursedStore.load();

    this.$on("tab-clicked", (event, tab) => {
      this.showExpenseAddView = false;
    });

    this.$on("close-add-expense", event => {
      this.showExpenseAddView = false;
    });
    this.expenseStore.getImportedExpenses();

    this.negativeDataSetFillGradient = [
      {
        alpha: 1.0,
        color: this.lightenedSecondaryColor
      },
      {
        alpha: 1.0,
        color: this.lightenedSecondaryColor
      }];
  }

  onSwitchPage (pageNumber): void {
    this.unreimbursedStore.loadPage({ page: pageNumber } as any);
  }

  getUnreimbursedList (): UnreimburseExpense[] {
    return this.unreimbursedStore.getExpensesList(this.unreimbursedStore.currentPage);
  }

  reimburseToggle (expense): void {
    this.unreimbursedStore.toggle(expense);
  }

  reimburseToggleAll (): void {
    this.unreimbursedStore.toggleAll(!this.unreimbursedStore.currentPageSelected);
  }

  graphNavigateBack (): void {
    this.unreimbursedStore.graphMove(true);
  }

  graphNavigateForward (): void {
    this.unreimbursedStore.graphMove(false);
  }

  tooltipGenerator (item): string {
    const heading = `<strong class="tooltip-type">${item.date}</strong>`;
    const description = `<div>Unreimbursed balance</div>`;
    const balanceMarkup = `<div class="tooltip-up">${formatCurrency(item.amount)}</div>`;

    return `<div style="width: auto; height: auto; padding: 8px; background: #fff; ` +
      `color: #666;` +
      `font-size: 12px; pointer-events: none;">${heading}${description}${balanceMarkup}</div>`;
  }

  onAddClick (event: any) {
    event.preventDefault();
    this.showExpenseAddView = !this.showExpenseAddView;
  }

  get lightenedSecondaryColor (): string {
    const secondaryColorRgb: RgbColor = covertHexToRgbColor(this.themeStore.secondaryColor);
    const tintedColor: RgbColor = tint(secondaryColorRgb.r, secondaryColorRgb.g, secondaryColorRgb.b, 0.6);

    return convertColorToHex(tintedColor);
  }

  get displayPilotExpenseTracker () {
    return this.expenseStore.importedExpenses.length > 0;
  }

  get bottomNotificationButtonText (): string {
    return this.custodianSettingsStore.allowReimbursement ? "Reimburse Me" : "Save";
  }

  handleNotificationClick (): void {
    if (this.custodianSettingsStore.allowReimbursement) {
      this.showReimbursePopup = true;
    } else {
      const params: ReimbursementRequest = {
        amount: this.reimburseAmount,
        reimbursementLinkedAccountId: 0,
        expenseIds: this.reimburseExpenseIds
      };
      this.reimburseMeStore.manualMarkedAsReimbursed(params);
    }
  }

  handleNotificationClose () {
    this.expenseBalanceSummaryStore.reimburseMeDismiss();
  }

  closeAll () {
    this.showReimbursePopup = false;
    this.expenseBalanceSummaryStore.reimburseMeDismiss();
  }

  get reimburseAmount () {
    return this.expenseBalanceSummaryStore.reimburseMeAmount.amount;
  }

  get reimburseExpenseIds () {
    return this.expenseBalanceSummaryStore.reimburseMeAmount.expenseIds;
  }
}
